import api from './api';

export const getIssues = (page, params) => {
  return api.get('admin/Issue', { params: { page: page, limit: 5, ...params } });
};

export const updateIssue = (issueId, update) => {
  return api.put(`admin/Issue/item/${issueId}`, { object: update });
};

export const getIssueMetrics = issueId => {
  return api.get(`admin/metrics/issue/${issueId}`);
};

export const getIssueInHtml = issueId => {
  return api.get(`admin/parsedIssue/${issueId}`);
};

export const resendIssue = issueId => {
  return api.post(`issue/resend/${issueId}`);
};

export const getIssueChangelog = uid => {
  return api.get(`admin/backup/issue/${uid}`);
};

export const editIssue = (uid, data) => {
  return api.put(`issue/${uid}`, data);
};

export const getIssuesWithoutCategory = (page, params) => {
  return api.get('admin/Issue', { params: { page: page, limit: 10, ...params } });
};

export const getAllCategoriesName = () => {
  return api.get('admin/category/allCategories');
};

export const assignCategoryToIssue = (uid, categoryId) => {
  return api.put(`admin/issue/${uid}/category/${categoryId}`);
};

export const clearCacheAndUpdateIssueLanguage = (id, language) => {
  return api.put(`admin/issue/${id}/language/${language}`);
};

export const sendTemplate = async (channelId, file) => {
  return api.post(`admin/send/issue/${channelId}`, file);
};
